import {IElement, IShapeCommonAttributes, ITextAttributes} from 'routes/private/Editor/types';

export const borderWidthResolver = ( element: IElement, value?: number ):IElement => {
    (element.attributes as IShapeCommonAttributes).borderWidth = value;
    return element;
}

export const borderDashResolver = ( element: IElement, value?: number ):IElement => {
    (element.attributes as IShapeCommonAttributes).borderDash = value;
    return element;
}

export const borderSpaceResolver = ( element: IElement, value?: number ):IElement => {
    (element.attributes as IShapeCommonAttributes).borderWhiteSpace = value;
    return element;
}

export const cornerRadiusResolver = ( element: IElement, value?: number ):IElement => {
    (element.attributes as IShapeCommonAttributes).cornerRadius = value;
    return element;
}